'use client';


import { useSession } from "next-auth/react"; // Import useSession
import { FiUser } from "react-icons/fi";
import { Link } from '@/i18n/routing';
import LanguageSelect from "./menu";
import Image from "next/image";
import MobileMenu from "./MobileMenu";
import { useTranslations } from 'next-intl';
import LoginButton from "./loginButton";
import CartIcon from "../products/cartIcon";
import { useLocale } from "next-intl";

export default function NavBar() {
  const te = useTranslations('tophero');
  const { data: session, status } = useSession(); // Get session and status
   const l = useLocale();
  function images() {
    return l == "ar" ? "/logo-black/شعار-بادليف-أسود.webp" :
      (l == "de" ? "/logo-black/padlev-logo-schwarz.webp" :
        (l == "es" ? "/logo-black/padlev-logo-negro.webp" :
          (l == "fr" ? "/logo-black/padlev-logo-noir.webp" :
            (l == "it" ? "/logo-black/padlev-logo-nero.webp" :
              (l == "nl" ? "/logo-black/padlev-logo-zwart.webp" :
                (l == "pt" ? "/logo-black/padlev-logo-preto.webp" :
                  (l == "ru" ? "/logo-black/padlev-logo-chernyy.webp" :
                    (l == "sv" ? "/logo-black/padlev-logo-svart.webp" :
                      "/logo-black/padlev-logo-black.webp"
                    )
                  )
                )
              )
            )
          )
        )
      );
  }

  return (
    <header className="bg-white shadow-sm">
      <nav className="flex items-center bg-yel justify-between py-3 w-full px-5" aria-label="Global">
        <div className="flex lg:flex-1 items-center gap-2">
          <MobileMenu />
          <Link href="/" rel="preload">
          <div className="relative h-5 w-32 ">
              <Image
                src={images()} // or "/logo.webp" if using an webp
                alt={te('logo-padlev')}
                fill
                sizes='100%'
                style={{ objectFit: 'contain' }} // Maintain aspect ratio
                priority // Ensures it loads faster
              />
            </div>
          </Link>
        </div>

        <LanguageSelect />

        <div className="gap-4 flex flex-auto justify-end">
          {/* Conditionally render user icon or login button */}
          {status === "authenticated" ? ( // If user is logged in
            <Link href="/account" rel="preload">
              <FiUser size={24} className="hover:text-bl " />
            </Link>
          ) : ( // If user is not logged in
            <LoginButton />
          )}

          {/* Cart icon */}
<CartIcon/>


        </div>
      </nav>
    </header>
  );
}



/**  <Link href="/cart" rel="preload">
            <div className="relative">
            {cart.length > 0 && (
            l == "ar" ?  <span className="absolute -top-1  left-4 flex h-5 w-5 items-center justify-center rounded-full bg-bl text-xs text-white">{totalQuantity}</span>
          :   <span className="absolute -top-2 -right-2 flex h-5 w-5 items-center justify-center rounded-full bg-bl text-xs text-white">{totalQuantity}</span>
          )}

              <PiShoppingCartSimple size={24} className="hover:text-bl" />
            </div>
          </Link> */